import { Link } from "react-router-dom";

const NotFound = () => (
    <div
        data-testid="not-found"
        className="min-h-[80vh] flex items-center justify-center px-5"
    >
        <div className="text-center">
            <p className="mono text-xs text-brand-green uppercase mb-3">
                / 404
            </p>
            <h1 className="display text-6xl md:text-8xl text-[#1a1a1a]">
                Off route.
            </h1>
            <p className="mt-6 text-gray-600 max-w-md mx-auto">
                That page isn't on our load board.
            </p>
            <Link to="/" className="btn-primary mt-8">
                Back to Home
            </Link>
        </div>
    </div>
);

export default NotFound;
